import { useRouter } from 'next/router';
import React, { FC } from 'react';

import { SubmitButton } from '@app/components/SubmitButton';
import { APP_ROUTES } from '@app/constants/routes';

interface Props {
  label?: string;
}

export const CreatePositionButton: FC<Props> = ({
  label = 'Add Liquidity'
}) => {
  const router = useRouter();

  return (
    <SubmitButton
      isLoading={false}
      onClick={() => {
        router.push(APP_ROUTES.addLiquidityPage);
      }}
      label={label}
      loadingText="Processing..."
      maxWidth="fit-content"
      mt={0}
    />
  );
};
